export default "__VITE_ASSET__0ALTrEQa__"